// export const BASE_URL = "https://app.skilledition.in";
// export const BASE_URL = "http://3.108.61.59:5000";
// export const BASE_URL = "https://apis.skilledition.in";
export const BASE_URL = "https://service.skilledition.in";


//admin signin
export const ADMIN_SIGNIN = BASE_URL + "/userroutes/adminlogin";

//student and tutor signin and signup
export const ROLE_BASED_API = {
  ROLE_BASED_SIGNUP: `${BASE_URL}/userroutes/adduser`,
  SEND_OTP: `${BASE_URL}/userroutes/sendotp`,
  ROLE_BASED_SIGNIN: `${BASE_URL}/userroutes/loginuser`,

  // ForgotPassword
  FORGOT_PASSWORD_OTP: `${BASE_URL}/userroutes/forgotpasswordotp`,
  VERIFY_OTP: `${BASE_URL}/userroutes/verifyOTP`,
  FORGOT_PASSWORD: `${BASE_URL}/userroutes/forgotpassword`,

  // LOGOUT_USER: `${BASE_URL}/userroutes/logoutUser`,
};

export const TUTOR_ONBOARDING_API = {
  TUTOR_ONBOARDING_ABOUT_ADD: `${BASE_URL}/tutor/addtutorabout`,
  TUTOR_ONBOARDING_PROFILE_ADD_AND_UPDATE: `${BASE_URL}/tutor/updatetutorprofile`,
  TUTOR_ONBOARDING_CERTIFICATE_ADD: `${BASE_URL}/tutor/addtutorcertificates`,
  TUTOR_ONBOARDING_EDUCATION_ADD: `${BASE_URL}/tutor/addtutoreducation`,
  TUTOR_ONBOARDING_EXPERIENCE_ADD_AND_UPDATE: `${BASE_URL}/tutor/updateTutorProfessionalDetails`,
  TUTOR_ONBOARDING_DEMO_VIDEO_ADD: `${BASE_URL}/tutor/adddemovideos`,
  TUTOR_ONBOARDING_DESCRIPTION_ADD_AND_UPDATE: `${BASE_URL}/tutor/updatedemovideodescription`,
  // TUTOR_ONBOARDING_PRICING_ADD_AND_UPDATE: `${BASE_URL}/tutor/updatedemovideoplandetails`,
  TUTOR_ONBOARDING_PRICING_ADD: `${BASE_URL}/tutor/addpaymentplan`,

  // GET API to fetch all onboarding steps by user ID
  TUTOR_ONBOARDING_GET_BY_USER_ID: `${BASE_URL}/tutor/gettutoronbardbyuserid`,

  //Update API's
  TUTOR_ONBOARDING_ABOUT_UPDATE: `${BASE_URL}/tutor/updatetutorabout`,
  TUTOR_ONBOARDING_CERTIFICATE_UPDATE: `${BASE_URL}/tutor/updatetutorcertificates`,
  TUTOR_ONBOARDING_EDUCATION_UPDATE: `${BASE_URL}/tutor/updatetutoreducation`,
  TUTOR_ONBOARDING_DEMO_VIDEO_UPDATE: `${BASE_URL}/tutor/updateDemovideo`,
  TUTOR_ONBOARDING_PRICING_UPDATE: `${BASE_URL}/tutor/updatepaymentplan`,

  //submit for admin review
  TUTOR_ONBOARDING_NOTIFICATION: `${BASE_URL}/tutor/tutoronboardnotification`,
  TUTOR_ONBOARDING_GET_STATUS: `${BASE_URL}/tutor/getonboardstatus`,
  TUTOR_USER_ROUTES_GET_USER: `${BASE_URL}/userroutes/getuser`,
};

export const CATEGORY_API = {
  GET_CATEGORY: `${BASE_URL}/category/getcategory`,
};

export const TUTOR_DASHBOARD_API = {
  TUTOR_DASHBOARDS: `${BASE_URL}/tutor/tutordashboards`,
};

export const TUTOR_COURSE_API = {
  ADD_COURSE: `${BASE_URL}/course/addcourse`,
  ADD_MODULE: `${BASE_URL}/course/add-module`,
  GET_TOTAL_COURSE: `${BASE_URL}/course/gettotalcourse`,
  GET__TUTORS_STUDENT_DETAILS_BY_ID: `${BASE_URL}/course/gettutorstudentdetailsbyid`,
  UPDATE_COURSE: `${BASE_URL}/course/updatecourse`,
  UPDATE_MODULE_VIDEOS: `${BASE_URL}/course/update-module-videos`,
  DELETE_MODULE: `${BASE_URL}/course/deletemodule`,
  DELETE_COURSE: `${BASE_URL}/course/deletecourse`,
  GET_TUTOR_COURSES_WITH_MODULES: `${BASE_URL}/course/getTutorCoursesWithModules`,
};

export const TUTOR_ASSIGNMENT_API = {
  // ADD_ASSIGNMENT: `${BASE_URL}/assignment/addassignment`,
  // ADD_ASSIGNMENT_QUESTIONS: `${BASE_URL}/assignment/addassignmentquestions`,
  ADD_ASSIGNMENT_WITH_QUESTIONS: `${BASE_URL}/assignment/addAssignmentWithQuestions`,
  GET_TUTOR_ASSIGNMENT_DETAILS: `${BASE_URL}/assignment/getTutorAssignmentDetails`,
  GET_ASSIGNMENT_BY_ID: `${BASE_URL}/assignment/getassignmentById`,
  GET_REJECTED_QUESTIONS: `${BASE_URL}/assignment/getRejectedQuestions`,
  UPDATE_REJECTED_QUESTIONS: `${BASE_URL}/assignment/updateRejectedQuestions`,
  DELETE_ASSIGNMENT: `${BASE_URL}/assignment/deleteAssignment`,

  //Submissions
  GET_TUTOR_FINAL_EXAM_STATUS: `${BASE_URL}/assignment/getTutorFinalExamStatus`,
  GET_FINAL_ASSIGNMENT_BY_ID: `${BASE_URL}/assignment/getfinalassignmentbyid`,
  UPDATE_TUTOR_FINAL_ASSIGNMENT_FEEDBACK: `${BASE_URL}/assignment/updatetutorfinalassingmentfeedback`,
};

export const TUTOR_STUDENT_DOUBTS_API = {
  CHAT_STATS: `${BASE_URL}/chat/chatstats`,
};

export const TUTOR_ANNOUNCEMENT_API = {
  CREATE_ANNOUNCEMENT: `${BASE_URL}/announcement/createanouncement`,
  GET_TUTOR_ANNOUNCEMENT: `${BASE_URL}/announcement/getTutorAnnouncements`,
  UPDATE_ANNOUNCEMENT: `${BASE_URL}/announcement/updateAnnouncement`,
  DELETE_ANNOUNCEMENT: `${BASE_URL}/announcement/deleteAnnouncement`,
};

export const TUTOR_ANALYTIC_API = {
  GET_ANALYTICS_ADMIN_DASHBOARD: `${BASE_URL}/dashboard/getTutorAnalytics`,
};

export const TUTOR_FEEDBACK_API = {
  GET_TUTOR_FEEDBACKS: `${BASE_URL}/feedbacks/get-tutor-feedbacks`,
  RESPOND_FEEDBACK: `${BASE_URL}/feedbacks/respond-feedback`,
};

export const TUTOR_NOTIFICATION_API = {
  GET_TUTOR_NOTIFICATION_DASHBOARD: `${BASE_URL}/notification/gettutorNotificationDashboard`,
};

export const TUTOR_PROFILE_SETTINGS_API = {
  TUTOR_CHANGE_PASSWORD: `${BASE_URL}/userroutes/tutorchangePassword`,
  GET_TUTOR_BANK_DETAILS: `${BASE_URL}/userroutes/getTutorBankDetail`,
  UPDATE_TUTOR_BANK_DETAILS: `${BASE_URL}/userroutes/updateTutorBankDetails`,
  TUTOR_GET_PROFILE: `${BASE_URL}/userroutes/tutorgetprofile`,
  TUTOR_UPDATE_PROFILE: `${BASE_URL}/userroutes/tutorupdateprofile`,
};

export const ADMIN_DASHBOARD_API = {
  GET_ADMIN_DASHBOARD_STATS: `${BASE_URL}/dashboard/getadminDashboardStats`,
};

export const ADMIN_COURSE_API = {
  GET_ADMIN_COURSE_LIST: `${BASE_URL}/course/getAdminCourseList`,
  GET_ADMIN_TOTAL_COURSE_WITH_STATUS: `${BASE_URL}/course/getadmintotalcoursewithstaus`,
  GET_MODULE_VIDEO_BY_ID: `${BASE_URL}/course/getModuleVideoById`,
  UPDATE_MODULE_VIDEO_STATUS: `${BASE_URL}/course/updatemodulevideostatus`,
  UPDATE_ADMIN_ASSIGNMENT_STATUS: `${BASE_URL}/course/updateadminassignmentstatus`,
  GET_ADMIN_COURSE_WITH_STATUS_ID: `${BASE_URL}/course/getadmincoursewithstatusid`,
};

export const ADMIN_TUTOR_API = {
  GET_ALL_TUTORS: `${BASE_URL}/tutor/getAllTutors`,
  GET_TUTOR_DETAILS_BY_STATUS: `${BASE_URL}/tutor/gettutordetailsbystatus`,
  GET_TUTOR_BY_ID: `${BASE_URL}/tutor/getTutorById`,
  UPDATE_TUTOR_STATUS: `${BASE_URL}/tutor/updateTutorStatus`,
  GET_TUTOR_DETAILS_BY_STATUS_ID: `${BASE_URL}/tutor/gettutordetailsbystatusid`,
};

export const ADMIN_STUDENT_API = {
  GET_ADMIN_STUDENT_MANAGEMENT: `${BASE_URL}/studentcourse/getadminstudentmanagement`,
  GET_ADMIN_STUDENT_MANAGEMENT_BY_ID: `${BASE_URL}/studentcourse/getadminstudentmanagementbyid`,

  //certificate
  GET_ALL_STUDENT_CERTIFICATES: `${BASE_URL}/assignment/getallstudentcertificates`,
};

export const ADMIN_FINAL_ASSIGNMENT_API = {
  GET_FINAL_ASSIGNMENTS_BY_ADMIN: `${BASE_URL}/assignment/getfinalassignmentsbyadmin`,
  UPDATE_FINAL_ASSIGNMENT_BY_ADMIN: `${BASE_URL}/assignment/updatefinalassigmentbyadmin`,
};

export const ADMIN_PLATFORM_ANALYTICS_STUDENT_PAYMENTS_API = {
  GET_ANALYTICS_ADMIN_DASHBOARD: `${BASE_URL}/dashboard/getanalyticsAdminDashboard`,
  STUDENT_PURCHASE_LIST: `${BASE_URL}/dashboard/studentpurchaselist`,
};

export const ADMIN_INTERNSHIP_API = {
  GET_TOTAL_INTERNSHIP: `${BASE_URL}/internship/gettotalinternship`,
  UPDATE_INTERNSHIP: `${BASE_URL}/internship/updateInternship`,
};

export const STUDENT_SIDEBAR_LOCK_API = {
  STUDENT_DASHBOARD_LOCK: `${BASE_URL}/student/studentdashboardlock`,
};

export const STUDENT_OVERVIEW_API = {
  GET_STUDENT_OVERVIEW: `${BASE_URL}/studentcourse/getstudentoverview`,
};

export const STUDENT_COURSE_API = {
  GET_ALL_COURSES_WITH_ENROLL_STATUS: `${BASE_URL}/studentcourse/getAllCoursesWithEnrollStatus`,
  GET_COURSE_ENROLL_DETAILS: `${BASE_URL}/studentcourse/getCourseenroleDetails`,
  BUY_COURSE: `${BASE_URL}/studentcourse/buycourse`,
  GET_STUDENT_COURSE: `${BASE_URL}/studentcourse/getstudentcourse`,
  UPDATE_WATCH_PROGRESS: `${BASE_URL}/studentcourse/updateWatchProgress`,
};

export const STUDENT_ASSIGNMENT_API = {
  GET_EXAM_STUDENT: `${BASE_URL}/studentcourse/getexamstudent`,
  GET_STUDENT_ASSIGNMENT_BY_ID: `${BASE_URL}/studentcourse/getAssignmentById`,
  WRITE_EXAM: `${BASE_URL}/studentcourse/writeExam`,
  GET_STUDENT_ASSIGNMENT_RESULT: `${BASE_URL}/studentcourse/getstudentassignmentresult`,
};

export const STUDENT_FINAL_ASSIGNMENT_API = {
  GET_FINAL_QUESTIONS: `${BASE_URL}/studentcourse/getfinalquestions`,
  WRITE_FINAL_EXAM: `${BASE_URL}/studentcourse/writeFinalExam`,
  UPDATED_TIME: `${BASE_URL}/studentcourse/updatedtime`,
  GET_FINAL_EXAM_RESULT: `${BASE_URL}/studentcourse/getfinalexamresult`,
};

export const STUDENT_FEEDBACK_API = {
  GET_STUDENT_COURSE_FEEDBACK: `${BASE_URL}/feedbacks/getStudentCoursefeedback`,
  ADD_FEEDBACK: `${BASE_URL}/feedbacks/addfeedback`,
};

export const STUDENT_CERTIFICATE_API = {
  GET_STUDENT_CERTIFICATES: `${BASE_URL}/assignment/getstudentcertificates`,
};

export const STUDENT_INTERNSHIP_API = {
  GET_INTERNSHIP: `${BASE_URL}/internship/getintership`,
  SUBMIT_INTERNSHIP: `${BASE_URL}/internship/submitintership`,
};

export const STUDENT_PROFILE_API = {
  UPDATE_PROFILE: `${BASE_URL}/student/updateprofile`,
  STUDENT_GET_PROFILE: `${BASE_URL}/student/getprofile`,
};

//student tutor admin
export const CHAT_API = {
  GET_CHAT_LIST: `${BASE_URL}/chat/getChatList`,
  GET_MESSAGES: `${BASE_URL}/chat/getMessages`,
  SEND_MESSAGE: `${BASE_URL}/chat/sendmessage`,
  UPDATE_MESSAGE: `${BASE_URL}/chat/updatemessage`,
  CLOSE_QUERY: `${BASE_URL}/chat/closeQuery`,
  UPDATE_PAUSE_CHAT: `${BASE_URL}/chat/updatepausechat`,
  GET_PAUSE_CHAT_LIST: `${BASE_URL}/chat/getpauseChatList`,
};

//student tutor admin
export const NOTIFICATION_API = {
  GET_NOTIFICATION: `${BASE_URL}/notification/getnotification`,
  MARK_NOTIFICATION_AS_READ: `${BASE_URL}/notification/markNotificationAsRead`,
  DELETE_NOTIFICATION: `${BASE_URL}/notification/deleteNotification`,
};

//student admin Purchase
export const PURCHASE_API = {
  GET_PURCHASE_LIST: `${BASE_URL}/studentcourse/getPurchaseList`,
  GET_PURCHASE_INVOICE: `${BASE_URL}/studentcourse/getPurchaseInvoice`,
  GET_ADMIN_PURCHASE_LIST: `${BASE_URL}/studentcourse/getadminPurchaseList`,
};

//public contact api
export const CONTACT_API = {
  ADD_CONTACT: `${BASE_URL}/contact/addcontact`,
};
